module.exports = __webpack_public_path__ + "style/img/banner2.7b6ccdb4.jpg";